export default "__VITE_ASSET__BNUSFm0I__"